import { useQuery } from '@tanstack/react-query';

import { getTimeSeriesTrackTarget } from '~/modules/artist-roster/lib/timeSeriesTarget';

interface TimeSeriesTrackTargetQueryProps {
  familyId?: string;
}

export const useTimeSeriesTrackTargetQuery = ({
  familyId,
}: TimeSeriesTrackTargetQueryProps) => {
  return useQuery({
    queryKey: ['timeseries-track-performance', familyId],
    queryFn: () => {
      return getTimeSeriesTrackTarget({ familyId: familyId! });
    },
    enabled: !!familyId,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  });
};
